import { useState, useEffect, useRef } from "react";
import cn from "classnames";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import coverFallback from '../../images/nocover.png';
import Spinner from 'react-bootstrap/Spinner';
import { request } from '../../functions/apiRequestWrapper';

const InternalPreview = ({ images, buttonText }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const timeoutRef = useRef(null);

  const onFirstImgLoad = () => {
    // console.log("image loaded");
    setLoading(false);
    setFirstLoaded(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
  const onFirstImgError = () => {
    // console.log("image error");
    setHasError(true);
    setLoading(false);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
  const onImgTimeout = () => {
    // console.log("image timeout");
    if (!firstLoaded) {
      setHasError(true);
    }
    setLoading(false);
  }

  useEffect(() => {
    timeoutRef.current = setTimeout(onImgTimeout, 20000);
    return () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
    <button type="button" className={cn("btn btn-primary me-2 mb-2", {"loading": loading})} onClick={()=>{ setOpen(true); }} style={hasError ? {display: "none"} : {}}>
      {loading && <Spinner animation="border" size="sm" variant={"light"} />}
      <span className="btntext">{buttonText}</span>
    </button>
    {images?.length > 0 && <div style={{width:"1px", height:"1px", overflow:"hidden"}}>
      <img src={images[0]} alt="" onLoad={onFirstImgLoad} onError={onFirstImgError} />
    </div>}
    <Lightbox
      open={open}
      close={()=>{ setOpen(false); }}
      slides={images.map((img,i) => {
        return {src: img, alt: ""}
      })}
      carousel={{finite: true}}
      plugins={[Thumbnails, Counter, Zoom]}
    />
    </>
  );
}

const CoverPreview = ({ imageUrl }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
    <img src={imageUrl} onError={(e)=>{e.target.onerror = null; e.target.src = coverFallback;}} alt="book cover preview" onClick={()=>{ setOpen(true); }} />
    <Lightbox
      open={open}
      close={()=>{ setOpen(false); }}
      slides={[
        {src: imageUrl, alt: "Cover"}
      ]}
      carousel={{finite: true}}
      plugins={[Zoom]}
    />
    </>
  );
}

const BookCoverWithPreview = ({ isbn, isOffline, imageUrl, onClickVideo, hasImages, hasMarketing, coverNotFinal, offlineInternalImages, offlineMarketingImages }) => {

  const [images, setImages] = useState(isOffline ? (offlineInternalImages || []) : []);
  const [marketing, setMarketing] = useState(isOffline ? (offlineMarketingImages || []) : []);

  useEffect(() => {
    if (!isOffline) {
      const controller = new AbortController();
      request(
        `${process.env.REACT_APP_API}/1/service/isbn/${isbn}?folderName=internal_images`,
        { signal: controller.signal }
      ).then((data) => {
        setImages(data);
      }).catch(() => {});
      request(
        `${process.env.REACT_APP_API}/1/service/isbn/${isbn}?folderName=marketing`,
        { signal: controller.signal }
      ).then((data) => {
        setMarketing(data);
      }).catch(() => {});
      return () => controller.abort();
    }
  }, [isbn, isOffline]);
  
  return (
    <div className="pt-5 pt-md-0 book-cover">
      <div className="book-cover-wrapper">
        {imageUrl &&
          <CoverPreview imageUrl={imageUrl} />
        }
        {!imageUrl &&
          <img src={coverFallback} alt="book cover preview" />
        }
        {coverNotFinal && 
          <div className="cover-not-final">Cover Not Final</div>
        }
        <div className="mt-2">
          {(hasImages || images.length > 0) &&
            <InternalPreview images={images} buttonText="View Inside" />
          }
          {(hasMarketing || marketing.length > 0) &&
            <InternalPreview images={marketing} buttonText="Marketing" />
          }
          {!isOffline && (typeof onClickVideo === 'function') &&
            <button type="button" className="btn btn-primary me-2 mb-2" onClick={(e) => { e.preventDefault(); onClickVideo(); }}>Video</button>
          }
        </div>
      </div>
    </div>
  );
}

export default BookCoverWithPreview;
